import { render, staticRenderFns } from "./MediaAlert.vue?vue&type=template&id=96beb468&"
import script from "./MediaAlert.vue?vue&type=script&lang=ts&"
export * from "./MediaAlert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports